let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("hUapU"), load("lRtGG"), load("8UKe0"), load("ffEVr"), load("hhss7"), load("9CRBg")]).then(() => parcelRequire('hCU0r'));